import { render, staticRenderFns } from "./VolunteerItem.vue?vue&type=template&id=19d0095b&scoped=true"
import script from "./VolunteerItem.vue?vue&type=script&lang=js"
export * from "./VolunteerItem.vue?vue&type=script&lang=js"
import style0 from "./VolunteerItem.vue?vue&type=style&index=0&id=19d0095b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d0095b",
  null
  
)

export default component.exports